import Axios from "axios";
import { getCookie } from "utils/cookies";

const logout = () => (window.location.href = "/authn/logout");
const dashboard = () => (window.location.href = "/dashboard");

const axios = Axios.create();
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Ignore 404 errors
        if (error.response?.status === 404) {
            return Promise.reject(error);
        }
        
        if (process.env.NODE_ENV !== "development") {
            if (getCookie("ssaSSOLogin") === "restrict" || getCookie("SSOLogin") === "restrict" || getCookie("mySLogin") === "restrict") {
                // redirect to /dashboard after 3 seconds
                setTimeout(dashboard, 3000);
            }
            if (getCookie("ssaSSOLogin") !== "loggedin" && getCookie("ssaSSOLogin") !== "restrict" && 
                getCookie("SSOLogin") !== "loggedin" && getCookie("SSOLogin") !== "restrict") {
                logout();
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
